import { $api } from "../generated/client";

export default function useTeamMembers(shopId: string) {
  return $api.useSuspenseQuery("get", "/shops/{shopId}/members", {
    params: { path: { shopId } },
  });
}
